function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.23,420.82l12.62,37.86a5.15,5.15,0,0,0,4.89,3.52h19.67a5.14,5.14,0,0,0,4.73-3.11l8.8-20.42",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.94,420.82l-12.62,37.86a5.15,5.15,0,0,1-4.89,3.52H243.76a5.14,5.14,0,0,1-4.73-3.11l-8.8-20.42",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-68"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.5,
    cy: 347.63,
    rx: 108.17,
    ry: 98.1,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.76,433l11,26.1a5.16,5.16,0,0,0,4.75,3.15h20a5.17,5.17,0,0,0,4.73-3.1l12-27.73-.52,0",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379,26.44l-55.31,79.69s-4.73,11.28-10.55,19.65S291,142.52,291,142.52s-1.45,15.64-6.18,21.1-14.92,2.19-14.92,2.19-4.37,4.73-9.1,6.91-19.28-5.82-19.28-5.82,13.09,14.19,14.91,18.92,5.1,8.73-.72,13.1-12.38-1.82-12.38-1.82,2.92,9.46-5.45,11.28S220.39,192,216.75,185.82s-14.19-29.48-16-30.57-4.36-6.91-.72-12.37S229.49,102.49,232.4,100,291,84.3,291,84.3l21.11-58.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.57,129.05s4.37,6.55,5.1,12.38a21.16,21.16,0,0,1-3.28,14.19c-2.18,3.27-4.36,6.18-6.18,11.28s-2.18,12.37-4.73,16-4,7.27-.37,10.55,13.1,2.91,18.2-6.55,8.37-19.65,11.64-23.29,13.83-12,13.83-12,28.74-4,34.2-9.09,10.19-18.92,10.19-18.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.19,59.92S89.42,98.52,51.63,158,16.83,294,62.75,350.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S441.6,283.74,432.6,195.52,344.07-21.88,165.19,59.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.19,59.92S89.42,98.52,51.63,158,16.83,294,62.75,350.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S441.6,283.74,432.6,195.52,344.07-21.88,165.19,59.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggy-bank--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.65,274.59a224.56,224.56,0,0,0-29.62-12c-14.62-4.5-31.87-.38-32.25,4.49S95,269.72,98.41,275s1.87,17.62,6.75,28.87,19.49,16.87,19.49,16.87Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,285.47s-22.5-14.25-35.62-19.13-13.87,2.25-13.87,2.25a10.89,10.89,0,0,1,7.13,10.63c0,8.42,4.21,25.86,14.44,29.46S144.9,285.47,144.9,285.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.1,
    cy: 289.96,
    rx: 11.39,
    ry: 12.23,
    transform: "translate(-83.34 125.82) rotate(-20.8)",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,420.82l12.62,37.86a5.15,5.15,0,0,0,4.89,3.52h19.67a5.14,5.14,0,0,0,4.73-3.11l8.8-20.42",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.56,420.82,161,458.68a4.43,4.43,0,0,0,4.06,3.52h16.31a4.31,4.31,0,0,0,3.92-3.11l7.3-20.42",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,420.82l12.62,37.86a5.15,5.15,0,0,0,4.89,3.52h19.67a5.14,5.14,0,0,0,4.73-3.11l8.8-20.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.15,420.82l-12.61,37.86a5.15,5.15,0,0,1-4.89,3.52H202a5.14,5.14,0,0,1-4.73-3.11l-8.8-20.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,420.82l-12.62,37.86a5.15,5.15,0,0,1-4.89,3.52H243.76a5.14,5.14,0,0,1-4.73-3.11l-8.8-20.42",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272,420.82l-8.63,37.86c-.48,2.1-1.82,3.52-3.34,3.52H246.58c-1.4,0-2.67-1.22-3.23-3.11l-8.36-20",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,420.82l-12.62,37.86a5.15,5.15,0,0,1-4.89,3.52H243.76a5.14,5.14,0,0,1-4.73-3.11l-8.8-20.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.5,
    cy: 347.63,
    rx: 108.17,
    ry: 98.1,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,280.6a90.11,90.11,0,0,1,9.65,40.56c0,54.18-48.43,98.1-108.17,98.1a115.37,115.37,0,0,1-62.75-18.18c18.86,25.31,50.79,42,87,42,58,0,105-42.61,105-95.18C318.67,321.59,306.93,297.82,288,280.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.5,
    cy: 347.63,
    rx: 108.17,
    ry: 98.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.57,356.43c-2.36,19.76-11.47,37.69-25.19,51.85",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.78,326a86.13,86.13,0,0,1,2.4,20.21",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.68,255.65a118.84,118.84,0,0,1,27.19-3.12,120.08,120.08,0,0,1,17.51,1.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.72,324.13s10.5-7.13,10.88-20.25-16.88-32.24-30.75-40.12-24-6.37-24.37-.75-5.25,12-7.12,22.87-2.63,27,12,32.25",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.13,319.92l2.15.32c9.22,1.33,12.46-4.69,12.19-13.73-.37-12.75-17.24-39.75-24.37-43.5s-9.37,1.5-9.37,1.5,1,.67-2.51,12.32c-1.62,5.38-7.65,24.14-1.68,32.46C193.82,316.64,203.63,318.65,212.13,319.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,307h-.14a1,1,0,0,1-.86-1.13,20,20,0,0,0,.19-2.32c.2-7-5.51-17.05-14.9-26.32a1,1,0,1,1,1.41-1.43c9.92,9.8,15.71,20.19,15.49,27.8a23.93,23.93,0,0,1-.2,2.54A1,1,0,0,1,242,307Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.62,319.06a1,1,0,0,1-.78-1.63,24.58,24.58,0,0,0,3.9-6.72,1,1,0,1,1,1.87.71,26.46,26.46,0,0,1-4.22,7.27A1,1,0,0,1,236.62,319.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.41,
    cy: 359.5,
    rx: 22.12,
    ry: 29.25,
    transform: "translate(-246.17 403.88) rotate(-75.99)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134,
    cy: 357.35,
    rx: 22.12,
    ry: 29.25,
    transform: "translate(-245.15 400.88) rotate(-75.99)",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,353.8c.18,2.68-.85,4.94-2.29,5s-2.77-2-3-4.68.85-4.95,2.3-5S125,351.11,125.18,353.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,358.77c.18,2.69-.85,4.94-2.29,5s-2.77-2-3-4.69.85-4.94,2.3-5S144.79,356.08,145,358.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,365.72a23.31,23.31,0,0,1-1.34,5.63c-5.74,15.51-26.52,22.22-47.05,15.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.36,
    y1: 364.25,
    x2: 180.73,
    y2: 364.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.78,322.73c-.7,2.91-2.49,5-4,4.62s-2.17-3-1.46-5.94,2.49-5,4-4.63S134.49,319.81,133.78,322.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.5,
    cy: 326.09,
    rx: 5.44,
    ry: 2.81,
    transform: "translate(-202.55 395.03) rotate(-76.45)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,433l11,26.1a5.16,5.16,0,0,0,4.75,3.15h20a5.17,5.17,0,0,0,4.73-3.1l12-27.73-.52,0",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,429.67c-6.34,0-13.72.83-19.69-.55l10.28,29.93a4.33,4.33,0,0,0,3.93,3.15H214a4.31,4.31,0,0,0,3.9-3.1l9.95-30.53-4,.55C211.16,430.5,211.49,429.67,203,429.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,433l11,26.1a5.16,5.16,0,0,0,4.75,3.15h20a5.17,5.17,0,0,0,4.73-3.1l12-27.73-.52,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379,26.44l-55.31,79.69s-4.73,11.28-10.55,19.65S291,142.52,291,142.52s-1.45,15.64-6.18,21.1-14.92,2.19-14.92,2.19-4.37,4.73-9.1,6.91-19.28-5.82-19.28-5.82,13.09,14.19,14.91,18.92,5.1,8.73-.72,13.1-12.38-1.82-12.38-1.82,2.92,9.46-5.45,11.28S220.39,192,216.75,185.82s-14.19-29.48-16-30.57-4.36-6.91-.72-12.37S229.49,102.49,232.4,100,291,84.3,291,84.3l21.11-58.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318,107s-6,18-12.5,21.5-43.5,13-58,11S225,132,225,132s-8,10.5-11.5,14a22.93,22.93,0,0,1-8.5,5s17.4,43.71,29.91,57.24a6,6,0,0,0,3,.14c8.37-1.82,5.45-11.28,5.45-11.28s6.55,6.18,12.38,1.82,2.54-8.37.72-13.1S241.5,166.9,241.5,166.9s14.55,8,19.28,5.82,9.1-6.92,9.1-6.92,10.19,3.28,14.92-2.18,6.18-21.1,6.18-21.1,16.37-8.37,22.2-16.74,10.55-19.65,10.55-19.65L346.52,73.3Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379,26.44l-55.31,79.69s-4.73,11.28-10.55,19.65S291,142.52,291,142.52s-1.45,15.64-6.18,21.1-14.92,2.19-14.92,2.19-4.37,4.73-9.1,6.91-19.28-5.82-19.28-5.82,13.09,14.19,14.91,18.92,5.1,8.73-.72,13.1-12.38-1.82-12.38-1.82,2.92,9.46-5.45,11.28S220.39,192,216.75,185.82s-14.19-29.48-16-30.57-4.36-6.91-.72-12.37S229.49,102.49,232.4,100,291,84.3,291,84.3l21.11-58.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.83 238.94 191.28 244.4 213.84 238.94 234.95 183.63 221.12 178.9 189.83 238.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.74 165.44 228.03 177.09 212.75 246.22 176 234.94 196.74 165.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.23 230.81 209.84 240.4 224.03 178.9 195.46 169.72 177.23 230.81",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.33,184.93a10.31,10.31,0,0,0-4.35-.2l-8.52,28.55a10.21,10.21,0,0,0,4.41,2.53c6.68,1.84,14-3.59,16.34-12.12S202,186.76,195.33,184.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12,189.66a.21.21,0,0,1-.12-.23l.38-1.48a.44.44,0,0,0-.36-.59l-1.59-.38a.43.43,0,0,0-.59.36l-.31,1.53a.2.2,0,0,1-.21.15,8,8,0,0,0-1.63,0l-2.91,9.77c2.27,2.36,5.81,3.54,5.34,5.52-.27,1.12-1.29,2-3.08,1.6a2.63,2.63,0,0,1-2.18-3.33l.09-.4c.05-.22-.08-.4-.39-.47l-.61-.15-1.73,5.78a7.18,7.18,0,0,0,2.39,1.44.21.21,0,0,1,.12.24l-.36,1.27a.42.42,0,0,0,.36.59l1.65.4A.43.43,0,0,0,189,211l.27-1.26a.23.23,0,0,1,.22-.16c3.52.37,5.91-1.36,6.65-4.44.58-2.46-.25-4.55-2.82-6.52-2.35-1.78-4.83-2.66-4.4-4.48.3-1.26,1.45-1.84,3-1.47a2.69,2.69,0,0,1,2.13,3.49l-.07.28c0,.17.1.32.41.4l2.93.7a.44.44,0,0,0,.59-.36l.22-.93C198.8,193.32,197.39,190.83,194.12,189.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.57,129.05s4.37,6.55,5.1,12.38a21.16,21.16,0,0,1-3.28,14.19c-2.18,3.27-4.36,6.18-6.18,11.28s-2.18,12.37-4.73,16-4,7.27-.37,10.55,13.1,2.91,18.2-6.55,8.37-19.65,11.64-23.29,13.83-12,13.83-12,28.74-4,34.2-9.09,10.19-18.92,10.19-18.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299,128.5s-15.5,10-27.5,13-19.5,3-24,9-9,25-15,28.5-7-9-15.5-6.5l-.28.1c-.83,3.9-1.56,7.9-3.24,10.31-2.55,3.64-4,7.27-.37,10.55s13.1,2.91,18.2-6.55,8.37-19.65,11.64-23.29,13.83-12,13.83-12,28.74-4,34.2-9.09c3.3-3.08,6.33-9.34,8.21-13.82Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.57,129.05s4.37,6.55,5.1,12.38a21.16,21.16,0,0,1-3.28,14.19c-2.18,3.27-4.36,6.18-6.18,11.28s-2.18,12.37-4.73,16-4,7.27-.37,10.55,13.1,2.91,18.2-6.55,8.37-19.65,11.64-23.29,13.83-12,13.83-12,28.74-4,34.2-9.09,10.19-18.92,10.19-18.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,147.25s9.47,5.09,16.38-.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.31,
    y1: 197.1,
    x2: 234.95,
    y2: 181.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.88,165.81s6.55-5.46,6.18-17.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-68"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 462.2,
    x2: 467,
    y2: 462.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 462.2,
    x2: 54,
    y2: 462.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.149febcf50eafcbc62b13e0ed5920471.svg";
export { ForwardRef as ReactComponent };